import React, { useState, useEffect } from "react";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import DoneIcon from "@mui/icons-material/Done";
import { toast } from "react-toastify";
import moment from "jalali-moment";
import CloseIcon from "@mui/icons-material/Close";

// import JS files
import TableIconModal from "../../../shares/TableIconModal";
import MuiButton from "../../../shares/MuiButton";
import useFetch from "../../../../context/useFetch";
import OrderCardLeftPartTemplate from "../../../shares/OrderCardLeftPartTemplate";
import AdminOrderCard from "../../shares/AdminOrderCard";
import MuiSelect from "../../../shares/MuiSelect";
import { EmptyData, fixNumbers } from "../../../../utils";
import SizeTextGrid from "../../../shares/SizeTextGrid";
import { useSetting } from "../../../../context/SettingContext";
import MuiModal from "../../../shares/MuiModal";
import { Divider } from "@mui/material";
import OrderCardLeftPartSubOrder from "../../../shares/OrderCardLeftPartSubOrder";
import DeliverSubOrderCard from "./DeliverSubOrderCard";
// import { defaultRingSize } from "../../../../constants/constants";

const statusList = [
  {
    name: "تغییر داده شده",
    value: true,
  },
  {
    name: "تغییر داده نشده",
    value: false,
  },
];

const DeliverOrderCustomer = (props) => {
  const { defaultRingSize } = useSetting();
  let windowWidth = window.screen.width;
  const [openModal, setOpenModal] = useState(false);
  const [openSeccondModal, setOpenSeccondModal] = useState(false);

  const [statusFilter, setStatusFilter] = useState("all");

  const [currentOerdersDetail, setCurrentOerdersDetail] = useState({
    results: [],
    detail: {},
  });
  const [initialValues, setInitialValues] = useState({});
  const [nums, setNums] = useState(new Array(defaultRingSize + 1).fill(""));
  const update_nums = (ringId, ind, nValue) => {
    let beforeNums = { ...initialValues };

    beforeNums[ringId][ind] = nValue;
    setInitialValues(beforeNums);
  };
  const [bangleCheckBox, setBangleCheckBox] = useState();

  const getOrderDetailsBangleApi = useFetch({
    method: "get",
    url: `Order_Service/${props.selectedRow?.id}/admin_get_bangle_detail_for_order`,
    trigger: false,
    // setter: setCurrentOerdersDetail,
    // params: { admin_change_item: statusFilter },
    argFunc: (res) => {
      setOrderBangleStatus({
        not_ready_list: res.not_ready_list,
        ready_list: res.ready_list,
        unchange_list: res.unchange_list,
      });

      let bangle_id = [];

      currentOerdersDetail.results.map((it, ind) => {
        if (res.ready_list.includes(it.id)) bangle_id.push(it.id);
      });

      setBangleCheckBox(bangle_id);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const changeCheckBoxStatus = (bangle_id) => {
    let bf = [...bangleCheckBox];
    if (bangleCheckBox.includes(bangle_id)) {
      let ind = bf.findIndex((ra) => ra == bangle_id);
      bf.splice(ind, 1);
    } else {
      bf.push(bangle_id);
    }
    setBangleCheckBox(bf);
  };
  const getOrderDetailsApi = useFetch({
    method: "get",
    url: `Order_Service/${props.selectedRow?.id}/admin_get_order_item_detail_from_order`,
    trigger: false,
    setter: setCurrentOerdersDetail,
    params: { admin_change_item: statusFilter },
    argFunc: (res) => {
      let tmp = {};
      res.results.map((item, ind) => {
        tmp[item.id] = [];
        tmp[item.id].push(item.admin_size_one_num);
        tmp[item.id].push(item.admin_size_two_num);
        tmp[item.id].push(item.admin_size_three_num);
        tmp[item.id].push(item.admin_size_four_num);
        tmp[item.id].push(item.admin_size_five_num);
        tmp[item.id].push(item.admin_size_six_num);
      });

      setInitialValues(tmp);
      getOrderDetailsBangleApi.reFetch();
    },
    errMessage: (mess) => {
      // toast.error("خطایی رخ داده است", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    },
  });
  const [selectedItem, setSelectedItem] = useState();
  const [patchData, setPatchData] = useState();
  const [childrenItemDate, setChildrenItemDate] = useState();
  const [orderBangleStatus, setOrderBangleStatus] = useState({
    not_ready_list: [],
    ready_list: [],
    unchange_list: [],
  });

  const updateOrderApi = useFetch({
    method: "post",
    url: `Order_Service/${props.selectedRow?.id}/create_new_order_factor`,
    trigger: false,
    // data: { state: "complete" },
    data: { order_items: orderBangleStatus.ready_list },

    argFunc: (res) => {
      // toast.success("سفارش با موفقیت  ویرایش شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      // setOpenSeccondModal(!openSeccondModal);

      setOpenModal(false);
      getOrderDetailsApi.reFetch();
      props.adminGetCustomerCurrentOrderApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const CreateNewOrder = useFetch({
    method: "post",
    url: `Order_Service/${props.selectedRow?.id}/create_new_order_factor`,
    trigger: false,
    data: { order_items: orderBangleStatus.ready_list },
    argFunc: (res) => {
      // toast.success("سفارش با موفقیت  ویرایش شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      // setOpenSeccondModal(!openSeccondModal);

      setOpenModal(false);
      getOrderDetailsApi.reFetch();

      props.adminGetCustomerCurrentOrderApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const create_new_order = () => {
    CreateNewOrder.reFetch();
  };

  const updateDetailsApi = useFetch({
    method: "patch",
    url: `OrderItem_Service/${selectedItem}/update_order_item`,
    trigger: false,
    data: patchData,

    argFunc: (res) => {
      // toast.success("سفارش با موفقیت  ویرایش شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      getOrderDetailsApi.reFetch();
      // props.adminGetCustomerCurrentOrderApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const resetUpdateDetailsApi = useFetch({
    method: "get",
    url: `OrderItem_Service/${selectedItem}/reset_update_order_item`,
    trigger: false,
    // data: patchData,

    argFunc: (res) => {
      setCurrentOerdersDetail({
        results: [],
        detail: {},
      });
      props.adminGetCustomerCurrentOrderApi.reFetch();

      getOrderDetailsApi.reFetch();
      getOrderDetailsBangleApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_ring_item = (ringItemId) => {
    setSelectedItem(ringItemId);
    setPatchData({
      admin_size_one_num:
        initialValues[ringItemId][0] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][0]))
          : 0,
      admin_size_two_num:
        initialValues[ringItemId][1] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][1]))
          : 0,
      admin_size_three_num:
        initialValues[ringItemId][2] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][2]))
          : 0,
      admin_size_four_num:
        initialValues[ringItemId][3] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][3]))
          : 0,
      admin_size_five_num:
        initialValues[ringItemId][4] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][4]))
          : 0,
      admin_size_six_num:
        initialValues[ringItemId][5] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][5]))
          : 0,
      receive_at: moment(childrenItemDate).format("YYYY-MM-DD"),
      admin_change_item: true,
    });
    updateDetailsApi.reFetch();
  };

  const reset_update_ring_item = (ringItemId) => {
    setSelectedItem(ringItemId);

    resetUpdateDetailsApi.reFetch();
  };

  const move_date_to_parent = (date) => {
    setChildrenItemDate(date);
  };

  const admin_change_order_to_on_complete = () => {
    updateOrderApi.reFetch();
  };

  const change_modal = () => {
    setOpenSeccondModal(!openSeccondModal);
  };

  useEffect(() => {
    if (openModal == true)
      if (props.selectedRow !== undefined)
        if (props.selectedRow.hasOwnProperty("id")) {
          getOrderDetailsApi.reFetch();
        }
  }, [openModal]);

  return (
    <>
      <TableIconModal
        width="w-11/12"
        icon={<DeliveryDiningIcon />}
        isOverflow={true}
        isNotBackdropClick={true}
        openModal={openModal}
        setOpenModal={setOpenModal}
        RefetchNeed
        apiCall={props.adminGetCustomerCurrentOrderApi}
      >
        <div>
          <div className="flex justify-between items-center mb-2 pb-2 border-dashed	 border-b">
            <div>
              <span className="show-label">
                سند:{" "}
                <span className="show-value">
                  {" "}
                  {props.selectedRow?.unique_id}
                </span>
              </span>
              <span> / </span>
              <span className="show-label">
                مشتری:{" "}
                <span className="show-value mx-2 shrink-0">
                  {" "}
                  {props.selectedRow?.name}
                </span>
              </span>
            </div>
            <div>
              <MuiButton
                onClick={admin_change_order_to_on_complete}
                // onClick={change_modal}
                variant="contained"
                icon={<DoneIcon />}
                color="primary"
                text={windowWidth > 768 ? "تحویل به مشتری" : "تحویل"}
                disabled={updateOrderApi.loading}
              />
            </div>
          </div>
          <div className="flex justify-between items-center mt-4">
            <span className="basis-1/2 md:basis-4/5 text-xs md:text-sm">
              برای مشاهده وضعیت سفارش ها فیلتر لازم را اعمال نمایید.
            </span>
            <div className="basis-1/2 md:basis-1/5">
              <MuiSelect
                size="small"
                inputLabel="وضعیت"
                labelId="status-label"
                id="status-select"
                label="status"
                menuItems={statusList}
                onChange={(e) => {
                  setStatusFilter(e.target.value);
                  getOrderDetailsApi.reFetch();
                }}
                value={statusFilter !== null ? statusFilter : "all"}
                defaultValue="all"
                haveAllOption={true}
              />
            </div>
          </div>
          <SizeTextGrid haveExtraCol have5Col />
          <div className="md:max-h-96 md:overflow-scroll">
            {currentOerdersDetail.results.length > 0 ? (
              <>
                {currentOerdersDetail.results.map((item, index) => {
                  return [
                    <AdminOrderCard
                      update_ring_item={update_ring_item}
                      reset_update_ring_item={reset_update_ring_item}
                      showResetAcceptBtn
                      showAcceptBtn
                      DontshowEditIconForAdmin
                      item={item}
                      move_date_to_parent={move_date_to_parent}
                      adminNeedDifference
                    >
                      <OrderCardLeftPartTemplate
                        nums={nums}
                        update_nums={update_nums}
                        dynamicMap={true}
                        data_item={item}
                        ringId={item.id}
                        adminDidntNeedCustomerRequestNum
                        adminNeedColor
                      />
                    </AdminOrderCard>,
                  ];
                })}
              </>
            ) : (
              <EmptyData text="نتیجه ای یافت نشد!" />
            )}
          </div>
        </div>
      </TableIconModal>
      {/* {openSeccondModal && (
        <MuiModal
          openModal={openSeccondModal}
          setOpenModal={setOpenSeccondModal}
          width="w-11/12"
          isOverflow={true}
          isNotBackdropClick={true}
        >
          <div>
            <div className="close-modal-icon">
              <CloseIcon
                onClick={() => setOpenSeccondModal(false)}
                fontSize="large"
                color="secondary"
              />
            </div>
            <div className="flex justify-center mb-6">
              <span className="show-label ">تحویل به مشتری</span>
            </div>

            <div className="flex flex-row justify-between mr-[3rem] ml-[3rem]">
              <span className="show-label ">
                آماده ارسال:{' '}
                <span className="show-value">
                  {orderBangleStatus.ready_list.length}
                </span>
              </span>
              <span className="show-label ">
                نیاز به بررسی:{' '}
                <span className="show-value">
                  {orderBangleStatus.not_ready_list.length}
                </span>
              </span>
              <span className="show-label ">
                تغییر داده نشده:{' '}
                <span className="show-value">
                  {orderBangleStatus.unchange_list.length}
                </span>
              </span>
            </div>
            <div className="m-2">
              <Divider />
              {currentOerdersDetail.results.map((item, index) => {
                return [
                  <DeliverSubOrderCard
                    update_ring_item={update_ring_item}
                    showResetAcceptIcon
                    showAcceptBtn
                    DontshowEditIconForAdmin
                    item={item}
                    move_date_to_parent={move_date_to_parent}
                    adminNeedDifference
                    bangleCheckBox={bangleCheckBox}
                    changeCheckBoxStatus={changeCheckBoxStatus}
                  >
                    <OrderCardLeftPartSubOrder
                      nums={nums}
                      update_nums={update_nums}
                      dynamicMap={true}
                      data_item={item}
                      ringId={item.id}
                      adminDidntNeedCustomerRequestNum
                      adminNeedColor
                      adminCantEdit
                    />
                  </DeliverSubOrderCard>,
                ];
              })}
            </div>
            <div className="flex flex-row justify-end mt-2">
              <div className="ml-2">
                <MuiButton
                  onClick={admin_change_order_to_on_complete}
                  variant="contained"
                  color="primary"
                  text={windowWidth > 768 ? 'تحویل همه به مشتری' : 'همه'}
                  disabled={updateOrderApi.loading}
                />
              </div>

              <MuiButton
                onClick={create_new_order}
                variant="contained"
                color="success"
                text={
                  windowWidth > 768
                    ? 'تحویل آماده ارسال به مشتری'
                    : 'آماده ارسال'
                }
                disabled={CreateNewOrder.loading}
              />
            </div>
          </div>
        </MuiModal>
      )} */}
    </>
  );
};

export default DeliverOrderCustomer;
